/** A child on a profile. `birth_ym` ("YYYY-MM") is the source of truth; `age_months` is a legacy snapshot. */
export interface ChildRecord {
  id?: string;
  birth_ym?: string | null;
  age_months?: number | null;
  estimated?: boolean;
}

/** Current age in whole months, derived from birth month so it grows over time. */
export function childAgeMonths(c: ChildRecord | null | undefined): number {
  if (!c) return 0;
  const m = c.birth_ym && /^(\d{4})-(\d{2})$/.exec(c.birth_ym);
  if (m) {
    const now = new Date();
    return Math.max(0, (now.getFullYear() - Number(m[1])) * 12 + (now.getMonth() + 1) - Number(m[2]));
  }
  return typeof c.age_months === "number" ? c.age_months : 0;
}

/** Birth month string for a child that is `months` old today. */
export function birthYmFromMonths(months: number): string {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() - months);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

/** Normalises a child for saving: keeps birth_ym and a fresh age_months snapshot. */
export function withAge<T extends ChildRecord>(c: T): T {
  return { ...c, age_months: childAgeMonths(c) };
}
